import React from 'react';

import getEntityUrl from 'url-constructors/getEntityUrl';

import PlaylistKPIs from 'components/data-containers/KPIs/Playlist/PlaylistKPIs';
import { MessageWithSmallMargin } from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';

import Anchor from 'components/base/Anchor/Anchor';
import { PlaylistProps } from 'pages/Entity/Artist/Performance/Playlist';

const Playlist: React.FC<PlaylistProps> = ({
  artist: { entityType, entityId },
  topic,
}) => {
  return (
    <div>
      <PlaylistKPIs />

      <Layout.MaxWidth>
        <MessageWithSmallMargin>
          Select an&nbsp;
          {entityId ? (
            <Anchor
              withChevron={false}
              isNewDesign
              to={getEntityUrl({
                entityType,
                entityId,
                topic,
              })}
            >
              artist&#39;s
            </Anchor>
          ) : (
            "artist's"
          )}
          &nbsp;track to see the playlist table.
        </MessageWithSmallMargin>
      </Layout.MaxWidth>
    </div>
  );
};

export default Playlist;
